import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    minWidth: '-webkit-fill-available',
    display: 'flex',
    justifyContent: 'space-between',
    clear: 'both',
    margin: `0 ${pxToRem(24)} 0 ${pxToRem(24)}`,
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    position: 'relative',
  },
  name: {
    color: theme.palette.neutralDark,
    float: 'left',
    wordBreak: 'break-word',
    padding: `${pxToRem(5)} 0 ${pxToRem(7)} ${pxToRem(16)}`,
    selectors: {
      '& p': {
        fontWeight: 'normal',
      },
    },
  },
  percapName: {
    fontSize: pxToRem(12),
  },
  purchasedUnits: {
    position: 'absolute',
    fontSize: pxToRem(12),
    color: theme.palette.neutralSecondary,
    fontWeight: 'normal',
    left: '25%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  returnCap: {
    position: 'absolute',
    fontSize: pxToRem(12),
    color: theme.palette.neutralSecondary,
    fontWeight: 'normal',
    left: '35%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  capLimit: {
    position: 'absolute',
    fontSize: pxToRem(12),
    color: theme.palette.neutralSecondary,
    fontWeight: 'normal',
    left: '45%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  actualReturns: {
    position: 'absolute',
    fontSize: pxToRem(12),
    color: theme.palette.accentError,
    wordBreak: 'break-all',
    fontWeight: 'normal',
    left: '55%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  returnsOverCap: {
    position: 'absolute',
    fontSize: pxToRem(12),
    color: theme.palette.accentError,
    wordBreak: 'break-all',
    fontWeight: 'normal',
    left: '65%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  returnsIncluded: {
    position: 'absolute',
    fontSize: pxToRem(12),
    color: theme.palette.accentError,
    wordBreak: 'break-all',
    fontWeight: 'normal',
    left: '75%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  footerReturnsIncluded: {
    position: 'absolute',
    fontSize: pxToRem(12),
    color: theme.palette.accentError,
    wordBreak: 'break-all',
    fontWeight: 'bold',
    left: '75%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  amount: {
    float: 'right',
    color: theme.palette.neutralDark,
    padding: `${pxToRem(5)} ${pxToRem(16)} ${pxToRem(7)} 0`,
    selectors: {
      '& p': {
        fontWeight: 'normal',
      },
    },
  },
  footerAmount: {
    float: 'right',
    color: theme.palette.neutralDark,
    padding: `${pxToRem(5)} ${pxToRem(16)} ${pxToRem(7)} 0`,
    selectors: {
      '& p': {
        fontWeight: 'bold',
      },
    },
  },
  details: {
    fontSize: pxToRem(12),
    fontWeight: 'normal',
    color: theme.palette.neutralSecondary,
    padding: `${pxToRem(7)} 0 ${pxToRem(9)} ${pxToRem(24)}`,
  },
  footerRow: {
    backgroundColor: theme.palette.neutralLighterAlt,
    margin: `0 ${pxToRem(24)} ${pxToRem(24)} ${pxToRem(24)}`,
    borderBottom: `none`,
  },
  boldBorderBottom: {},
  bold: {
    fontWeight: 'bold',
    borderBottom: `${pxToRem(2)} solid ${theme.palette.black}`,
    selectors: {
      '& p': {
        fontWeight: 'bold',
      },
    },
  },
  percapNonDetailRow: {
    backgroundColor: theme.palette.neutralLighterAlt,
  },
  percapFooterRow: {
    backgroundColor: `${theme.palette.neutralLight} !important`,
    selectors: {
      '& p': {
        fontWeight: 'bold',
      },
    },
  },
  negativeValue: {
    color: theme.palette.accentError,
    wordBreak: 'break-all',
  },
});
